export const videolar = {
  title: 'Videolar',
  titleEN: 'Videos',
  description: 'Youtube, Instagram, Tiktok, Facebook, New-Gen Short Form video ya da Canlı Yayın. Mackolik Video bugne kadar birden fazla spor branşında yzlerce video retti ve milyonlarca izlenme aldı. Kreatif, Prodksiyon, Post Prodksiyon ve Medya’yı tek elden birleştiren ender ekiplerden biri. Hem hızlı hem de cost-efektif!',
  descriptionEN: 'YouTube, Instagram, TikTok, Facebook, New-Gen Short Form videos, or Live Streams. Mackolik Video has produced hundreds of videos across multiple sports branches and garnered millions of views. It is one of the rare teams that combine Creative, Production, Post-Production, and Media under one roof. Both fast and cost-effective!',
  tabs: [
    {
      id: 1,
      title: 'Video Tanıtım',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Mackolik Tanıtım Videosu',
          image: 'https://srv-cdn.onedio.com/store/ef82a887959aec220612a75d827d27dcf2cd84cf0cac4be71c305b1287bd15dc.png',
          video: 'https://proj-assets.onedio.com/sunum/mackolik/mackolik-tanitim.mp4',
          modal: 'video',
          modalTitle: 'Mackolik Tanıtım Videosu'
        }
      ]
    },
    {
      id: 2,
      title: 'Live',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'MackoLig',
          image: 'https://srv-cdn.onedio.com/store/3b727367bb2da892ea11b0f348603eb74043bb9bf629c0f1e374effb5764c917.png',
          url: 'https://www.youtube.com/embed/HTLADtayxEY',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'MackoLig'
        },
        {
          id: 2,
          name: 'Ülke Puanı',
          image: 'https://srv-cdn.onedio.com/store/7c27121c408d5bc4927fc0532fb2a52569f12b273a8b6db88216475f9a31e8aa.png',
          url: 'https://www.youtube.com/embed/wLRnF7jy4Do',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Ülke Puanı'
        },
        {
          id: 3,
          name: 'Cem Dizdar ile Akıntıya Karşı',
          image: 'https://srv-cdn.onedio.com/store/2df4864512610157c6cd560cf6a42c7cbc2f1f733ef2a618a3322099d8b797e8.png',
          url: 'https://www.youtube.com/embed/7_rWb8pcZQg',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Cem Dizdar ile Akıntıya Karşı'
        },
      ]
    },
    {
      id: 3,
      title: 'VOD',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Kurşun Pas',
          image: 'https://srv-cdn.onedio.com/store/783212487dafd020fd91117947a86bf4f77e2aeaaa9862f7951d645fcf68957f.png',
          url: 'https://www.youtube.com/embed/x-YM2I1zS4M?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Kurşun Pas'
        },
        {
          id: 2,
          name: 'Kimdir',
          image: 'https://srv-cdn.onedio.com/store/ed05653ce3fba0f61eb1c2f93c138233fa81e7bdc24b538bf4b78f91c41e80f1.png',
          url: 'https://www.youtube.com/embed/MNu0HzCe9TI?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Kimdir'
        },
        {
          id: 3,
          name: 'Pasaport',
          image: 'https://srv-cdn.onedio.com/store/7919cd972fedf57af1388166511fb5f134219c6538369213d4f089b98dae69b2.png',
          url: 'https://www.youtube.com/embed/cuqffDB-O-M?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Pasaport'
        },
        {
          id: 4,
          name: 'Hava Atışı',
          image: 'https://srv-cdn.onedio.com/store/9eb3dd2af32e06a4a5b7e9b194339d0e43296768df7f5122400c5daa012b698b.png',
          url: 'https://www.youtube.com/embed/yYQJczrROTg?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Hava Atışı'
        },
        {
          id: 5,
          name: 'Araba Sevdası',
          image: 'https://srv-cdn.onedio.com/store/5d091db70c925e4be8c66afb0f25be1162d1987ed6e4b890625e9cbb14b86581.png',
          url: 'https://www.youtube.com/embed/lqDEyjCCdz8?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Araba Sevdası'
        },
        {
          id: 6,
          name: 'Yüz Yüze',
          image: 'https://srv-cdn.onedio.com/store/38ff283ba508a7fe9fd862eb28f9b4e4eeece5f7e7272dae72403e57e6e95f27.png',
          url: 'https://www.youtube.com/embed/vHO44ryAToQ?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Yüz Yüze'
        },
        {
          id: 7,
          name: 'Sessiz Derbi',
          image: 'https://srv-cdn.onedio.com/store/70cc2d210c5c571e0a1311df69f7df0965563ec499a381b37a9a3bac4bd4788a.png',
          url: 'https://www.youtube.com/embed/LHM83O94pe0?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Sessiz Derbi'
        },
      ]
    },
    {
      id: 4,
      title: 'Newgen',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Neymiş',
          image: 'https://srv-cdn.onedio.com/store/7bbde6a89cee9c20b99ee8e8e18588840f1be0c691dc97d222b96eeb45356d0e.png',
          url: 'https://www.youtube.com/embed/uch4v5LWYHQ',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Neymiş'
        },
        {
          id: 2,
          name: 'Tic Tac Toe',
          image: 'https://srv-cdn.onedio.com/store/f5314f608d871d98ec77312dddd3c325e15ad6d5d6d7e150bbf1b61f4679f354.png',
          url: 'https://www.youtube.com/embed/uH8FqbHQzfQ',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Tic Tac Toe'
        },
        {
          id: 3,
          name: 'Mackolik Her Yerde',
          image: 'https://srv-cdn.onedio.com/store/9e3d608a855150f73158dc511756e77b259fc1959634ac6e4afd4ecfb32b582e.png',
          url: 'https://www.instagram.com/reel/CzjF5GWoBus/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Mackolik Her Yerde'
        },
        {
          id: 4,
          name: 'Bu Logo Kimin',
          image: 'https://srv-cdn.onedio.com/store/75839ca4de024722aa93ac05da88b054394720fd46c9ecb96ead439346b2c158.png',
          url: 'https://www.youtube.com/embed/3Sda1jRRXp0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Bu Logo Kimin'
        },
        {
          id: 5,
          name: 'Kimin Golü Fazla',
          image: 'https://srv-cdn.onedio.com/store/3dc96ddea13f7ebbd13e4ca1b63bc48eb75dbe372711f68dea6c6f568d2c3a55.png',
          url: 'https://www.youtube.com/embed/WaVBaa0LU-s',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Kimin Golü Fazla'
        },
        {
          id: 6,
          name: 'Bu Forma Kimin',
          image: 'https://srv-cdn.onedio.com/store/845bdd7e2443997771f5208e6473dc48fccdae333169e7c4f0636ffab0ccbca2.png',
          url: 'https://www.youtube.com/embed/qU33LDvpUR4',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Bu Forma Kimin'
        },
        {
          id: 7,
          name: 'Kim Daha Genç',
          image: 'https://srv-cdn.onedio.com/store/9a5d3604b1996669a8330d5beac62761d043b0b4bac9d2952b413580048e32d8.png',
          url: 'https://www.youtube.com/embed/zH_1JWgmJKM',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Kim Daha Genç'
        },
        {
          id: 8,
          name: 'Bu Hangi Takım',
          image: 'https://srv-cdn.onedio.com/store/48335a08c69c2b5c88ebcdcdc5f0ff6e0211372b554a645e470868d90f66cb20.png',
          url: 'https://www.youtube.com/embed/QYOod9OICdM',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Bu Hangi Takım'
        },
      ]
    }
  ],
  egTabs: [
    {
      id: 1,
      title: 'Video Intro',
      sliderPerView: 1,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Mackolik Intro Video',
          image: 'https://srv-cdn.onedio.com/store/ef82a887959aec220612a75d827d27dcf2cd84cf0cac4be71c305b1287bd15dc.png',
          video: 'https://proj-assets.onedio.com/sunum/mackolik/mackolik-tanitim.mp4',
          modal: 'video',
          modalTitle: 'Mackolik Intro Video'
        }
      ]
    },
    {
      id: 2,
      title: 'Live',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'MackoLig',
          image: 'https://srv-cdn.onedio.com/store/3b727367bb2da892ea11b0f348603eb74043bb9bf629c0f1e374effb5764c917.png',
          url: 'https://www.youtube.com/embed/HTLADtayxEY',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'MackoLig'
        },
        {
          id: 2,
          name: 'Ülke Puanı',
          image: 'https://srv-cdn.onedio.com/store/7c27121c408d5bc4927fc0532fb2a52569f12b273a8b6db88216475f9a31e8aa.png',
          url: 'https://www.youtube.com/embed/wLRnF7jy4Do',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Ülke Puanı'
        },
        {
          id: 3,
          name: 'Cem Dizdar ile Akıntıya Karşı',
          image: 'https://srv-cdn.onedio.com/store/2df4864512610157c6cd560cf6a42c7cbc2f1f733ef2a618a3322099d8b797e8.png',
          url: 'https://www.youtube.com/embed/7_rWb8pcZQg',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Cem Dizdar ile Akıntıya Karşı'
        },
      ]
    },
    {
      id: 3,
      title: 'VOD',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Kurşun Pas',
          image: 'https://srv-cdn.onedio.com/store/783212487dafd020fd91117947a86bf4f77e2aeaaa9862f7951d645fcf68957f.png',
          url: 'https://www.youtube.com/embed/x-YM2I1zS4M?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Kurşun Pas'
        },
        {
          id: 2,
          name: 'Kimdir',
          image: 'https://srv-cdn.onedio.com/store/ed05653ce3fba0f61eb1c2f93c138233fa81e7bdc24b538bf4b78f91c41e80f1.png',
          url: 'https://www.youtube.com/embed/MNu0HzCe9TI?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Kimdir'
        },
        {
          id: 3,
          name: 'Pasaport',
          image: 'https://srv-cdn.onedio.com/store/7919cd972fedf57af1388166511fb5f134219c6538369213d4f089b98dae69b2.png',
          url: 'https://www.youtube.com/embed/cuqffDB-O-M?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Pasaport'
        },
        {
          id: 4,
          name: 'Hava Atışı',
          image: 'https://srv-cdn.onedio.com/store/9eb3dd2af32e06a4a5b7e9b194339d0e43296768df7f5122400c5daa012b698b.png',
          url: 'https://www.youtube.com/embed/yYQJczrROTg?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Hava Atışı'
        },
        {
          id: 5,
          name: 'Araba Sevdası',
          image: 'https://srv-cdn.onedio.com/store/5d091db70c925e4be8c66afb0f25be1162d1987ed6e4b890625e9cbb14b86581.png',
          url: 'https://www.youtube.com/embed/lqDEyjCCdz8?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Araba Sevdası'
        },
        {
          id: 6,
          name: 'Yüz Yüze',
          image: 'https://srv-cdn.onedio.com/store/38ff283ba508a7fe9fd862eb28f9b4e4eeece5f7e7272dae72403e57e6e95f27.png',
          url: 'https://www.youtube.com/embed/vHO44ryAToQ?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Yüz Yüze'
        },
        {
          id: 7,
          name: 'Sessiz Derbi',
          image: 'https://srv-cdn.onedio.com/store/70cc2d210c5c571e0a1311df69f7df0965563ec499a381b37a9a3bac4bd4788a.png',
          url: 'https://www.youtube.com/embed/LHM83O94pe0?rel=0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Sessiz Derbi'
        },
      ]
    },
    {
      id: 4,
      title: 'Newgen',
      sliderPerView: 3,
      width: '100%',
      slides: [
        {
          id: 1,
          name: 'Neymiş',
          image: 'https://srv-cdn.onedio.com/store/7bbde6a89cee9c20b99ee8e8e18588840f1be0c691dc97d222b96eeb45356d0e.png',
          url: 'https://www.youtube.com/embed/uch4v5LWYHQ',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Neymiş'
        },
        {
          id: 2,
          name: 'Tic Tac Toe',
          image: 'https://srv-cdn.onedio.com/store/f5314f608d871d98ec77312dddd3c325e15ad6d5d6d7e150bbf1b61f4679f354.png',
          url: 'https://www.youtube.com/embed/uH8FqbHQzfQ',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Tic Tac Toe'
        },
        {
          id: 3,
          name: 'Mackolik Her Yerde',
          image: 'https://srv-cdn.onedio.com/store/9e3d608a855150f73158dc511756e77b259fc1959634ac6e4afd4ecfb32b582e.png',
          url: 'https://www.instagram.com/reel/CzjF5GWoBus/embed',
          width: '440px',
          height: '85vh',
          modal: 'iframe',
          modalTitle: 'Mackolik Her Yerde'
        },
        {
          id: 4,
          name: 'Bu Logo Kimin',
          image: 'https://srv-cdn.onedio.com/store/75839ca4de024722aa93ac05da88b054394720fd46c9ecb96ead439346b2c158.png',
          url: 'https://www.youtube.com/embed/3Sda1jRRXp0',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Bu Logo Kimin'
        },
        {
          id: 5,
          name: 'Kimin Golü Fazla',
          image: 'https://srv-cdn.onedio.com/store/3dc96ddea13f7ebbd13e4ca1b63bc48eb75dbe372711f68dea6c6f568d2c3a55.png',
          url: 'https://www.youtube.com/embed/WaVBaa0LU-s',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Kimin Golü Fazla'
        },
        {
          id: 6,
          name: 'Bu Forma Kimin',
          image: 'https://srv-cdn.onedio.com/store/845bdd7e2443997771f5208e6473dc48fccdae333169e7c4f0636ffab0ccbca2.png',
          url: 'https://www.youtube.com/embed/qU33LDvpUR4',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Bu Forma Kimin'
        },
        {
          id: 7,
          name: 'Kim Daha Genç',
          image: 'https://srv-cdn.onedio.com/store/9a5d3604b1996669a8330d5beac62761d043b0b4bac9d2952b413580048e32d8.png',
          url: 'https://www.youtube.com/embed/zH_1JWgmJKM',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Kim Daha Genç'
        },
        {
          id: 8,
          name: 'Bu Hangi Takım',
          image: 'https://srv-cdn.onedio.com/store/48335a08c69c2b5c88ebcdcdc5f0ff6e0211372b554a645e470868d90f66cb20.png',
          url: 'https://www.youtube.com/embed/QYOod9OICdM',
          width: '640px',
          height: '360px',
          modal: 'iframe',
          modalTitle: 'Bu Hangi Takım'
        },
      ]
    }
  ]
}
